import { useModelValue } from "@soft-db/soft-utils";
import { Button, Tooltip } from "@soft-db/ui";
import { PropType } from "vue";

export default defineComponent({
	name: "WeekdaysSelector",
	props: {
		modelValue: {
			type: Array as PropType<number[]>,
			default: () => [],
		},
	},
	setup(props) {
		const { t } = useI18n();

		const weekdays = useModelValue(props);

		const firstLetter = (word: string | any) => word.slice(0, 1);
		const weekLabel = computed(() => [
			t("common.sunday"),
			t("common.monday"),
			t("common.tuesday"),
			t("common.wednesday"),
			t("common.thursday"),
			t("common.friday"),
			t("common.saturday"),
		]);

		const toggleWeekday = (index: number) => {
			const foundIndex = weekdays.value.findIndex((day) => day === index);
			if (foundIndex !== -1) {
				weekdays.value.splice(foundIndex, 1);
			} else {
				weekdays.value.push(index);
				weekdays.value.sort();
			}
		};

		const weekDaySelected = (index: number) => {
			return weekdays.value.includes(index);
		};

		function weekDayButtons() {
			return weekLabel.value.map((label, i) => (
				<Tooltip tooltip={label}>
					<Button
						key={i}
						class="hover:btn-primary"
						variant={weekDaySelected(i) ? "default" : "soft"}
						shape="round"
						size="md"
						color={weekDaySelected(i) ? "primary" : "default"}
						onClick={() => toggleWeekday(i)}
					>
						{firstLetter(label)}
					</Button>
				</Tooltip>
			));
		}

		return () => <div class="flex justify-around">{weekDayButtons()}</div>;
	},
});
